var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 22.82 18.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#008fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18,0H2A2,2,0,0,0,0,2V14a2,2,0,0,0,2,2H13.47a5.57,5.57,0,0,1-.17-1.36,4.49,4.49,0,0,1,0-.64H2V8H18V9.13a4.4,4.4,0,0,1,.89-.08A5.8,5.8,0,0,1,20,9.16V2A2,2,0,0,0,18,0Zm0,4H2V2H18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.07,18.8V10.48H17.8V18.8Zm1.64,0V17.33h.73a2.57,2.57,0,0,0,1.92-.66A2.59,2.59,0,0,0,21,14.76a3,3,0,0,0-.64-2.09A2.48,2.48,0,0,0,18.44,12h-.7l-.16-1.48h.86q4.38,0,4.38,4.28,0,4-4.38,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCard);
export default __webpack_public_path__ + "static/media/debit-card.692aa7c5a02ed8ae7ef645a2201c169f.svg";
export { ForwardRef as ReactComponent };